export default ".article-author-card-four--compact { border-radius:24px; background:#eef0ff; }\n";